<div class="container" [class.htv-selectable]="selectable" (click)="onClick()">
  <div class="content">
    {{ text }}
  </div>
</div>
